export enum DateFormatOptions {
  DATEONLY = 'date',
  DATEANDTIME = 'date-and-time',
}

export const formatDate = (
  date: Date | string | undefined,
  format: DateFormatOptions = DateFormatOptions.DATEANDTIME
) => {
  if (!date) return 'Never';
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    ...(format === DateFormatOptions.DATEANDTIME && {
      hour: '2-digit',
      minute: '2-digit',
    }),
  });
};

export default formatDate;
